/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { UnitProperty } from './UnitProperty';
import {
    UnitPropertyFromJSON,
    UnitPropertyFromJSONTyped,
    UnitPropertyToJSON,
} from './UnitProperty';

/**
 * 
 * @export
 * @interface Units
 */
export interface Units {
    /**
     * 
     * @type {Command}
     * @memberof Units
     */
    changeColumnUnitCommand: Command;
    /**
     * 
     * @type {Array<UnitProperty>}
     * @memberof Units
     */
    unitProperties: Array<UnitProperty>;
}

/**
 * Check if a given object implements the Units interface.
 */
export function instanceOfUnits(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "changeColumnUnitCommand" in value;
    isInstance = isInstance && "unitProperties" in value;

    return isInstance;
}

export function UnitsFromJSON(json: any): Units {
    return UnitsFromJSONTyped(json, false);
}

export function UnitsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Units {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'changeColumnUnitCommand': CommandFromJSON(json['changeColumnUnitCommand']),
        'unitProperties': ((json['unitProperties'] as Array<any>).map(UnitPropertyFromJSON)),
    };
}

export function UnitsToJSON(value?: Units | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'changeColumnUnitCommand': CommandToJSON(value.changeColumnUnitCommand),
        'unitProperties': ((value.unitProperties as Array<any>).map(UnitPropertyToJSON)),
    };
}

